import React, { useState, useEffect, useRef } from "react";
import { gl_start, registerSceneHMR, setUniform } from "./webgl0.js";

function Scene() {

this.vertexShader = `\
#version 300 es
in  vec3 aPos;
out vec3 vPos;
void main() {
   gl_Position = vec4(aPos, 1.);
   vPos = aPos;
}`;

this.fragmentShader = `\
#version 300 es
precision highp float;
uniform float uTime;
uniform vec3 uViewPoint;
in  vec3 vPos;
out vec4 fragColor;

// TEXTURE FUNCTIONS

vec3  _s(vec3 i) { return cos(5.*(i+5.*cos(5.*(i.yzx+5.*cos(5.*(i.zxy+5.*cos(5.*i))))))); }

float _t(vec3 i, vec3 u, vec3 a) { return dot(normalize(_s(i + a)), u - a); }

float noise(vec3 p) {
   vec3 i = floor(p), u = p - i, v = 2.*mix(u*u, u*(2.-u)-.5, step(.5,u));
   return mix(mix(mix(_t(i, u, vec3(0.,0.,0.)), _t(i, u, vec3(1.,0.,0.)), v.x),
                  mix(_t(i, u, vec3(0.,1.,0.)), _t(i, u, vec3(1.,1.,0.)), v.x), v.y),
              mix(mix(_t(i, u, vec3(0.,0.,1.)), _t(i, u, vec3(1.,0.,1.)), v.x),
                  mix(_t(i, u, vec3(0.,1.,1.)), _t(i, u, vec3(1.,1.,1.)), v.x), v.y), v.z);
}

float turbulence(vec3 P) {
   float f = 0., s = 1.;

   for (int i = 0 ; i < 9 ; i++) {
      // f += noise(s * P) / s;
      f += abs(noise(s * P)) / s;

      s *= 2.;
      P = vec3(.866 * P.x + .5 * P.z, P.y + 100., -.5 * P.x + .866 * P.z);
   }
   return f;
}

void main() {
   vec4 F = vec4(0.);

   float x = 1.2 * vPos.x;
   float y = 1.2 * vPos.y;
   float z = sqrt(1. - x*x - y*y);

   if (z > 0.0) { // Only render front half of sphere
      vec3 P = vec3(x, y, z);
      vec3 N = normalize(P); // SURFACE NORMAL
      vec3 lightDir = normalize(vec3(1., 1., 1.));

      // KNOBS FOR TEXTURE
      float scale = 5.0;        // How dense/frequent the texture is
      float contrast = 0.05;    // How much light/dark variation
      float brightness = 1.0;   // Base gray level

      float tb = turbulence(scale * P); // turbulence value per point P

      // CREATE BUMP EFFECT
      float bumpStrength = 0.1;  // How "tall" the bumps are
      float delta = 0.04;        // How far to sample for slope calculation

      float tx = turbulence(scale * (P + vec3(delta, 0., 0.)));
      float ty = turbulence(scale * (P + vec3(0., delta, 0.)));
      float tz = turbulence(scale * (P + vec3(0., 0., delta)));
      vec3 gradient = vec3(tx - tb, ty - tb, tz - tb) / delta; // NEW: Calculate how much texture changes in each direction

      N = normalize(N - bumpStrength * gradient);

      vec3 c = vec3(brightness + contrast * (tb - 0.5));

      // LIGHTING
      float diffuse = max(0., dot(N, lightDir));

      vec3 viewDir = normalize(vec3(0., 0., 1.));
      float rim = pow(1.0 - max(0., dot(N, viewDir)), 3.0);
      float lighting = 0.2 + 0.6 * diffuse + 0.3 * rim;
      
      c *= lighting;

      F = vec4(c, 1.0);
      F.r += 0.4;
   }

   fragColor = vec4(sqrt(F.rgb), F.a);
}`;

let startTime = Date.now()/1000;

this.update = (viewPoint = [0, 0, 7]) => {
   let time = Date.now()/1000 - startTime;
   setUniform('1f', 'uTime', time);
   setUniform('3fv', 'uViewPoint', viewPoint);
}

}

export default function WebGLCanvas() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    try { if (typeof canvas.stopRender === "function") canvas.stopRender(); } catch (e) {}

    const newScene = new Scene();

    gl_start(canvas, newScene);

    try { registerSceneHMR(module, canvas, () => new Scene()); } catch (e) { /* ignore */ }
    return () => { try { if (typeof canvas.stopRender === "function") canvas.stopRender(); } catch (e) {} };
  }, []);

  return (
    <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
      <canvas ref={canvasRef} width={400} height={400}
        style={{ width: "400px", height: "400px", display: "block", margin: "0 auto", background: "black" }} />
        <pre className = "codeblock-shader">{ Scene.toString() }</pre>
    </div>
  );
}
